export { default } from "./DetailsContainer";
